import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Degree of Change by Team',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Degree of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'High',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'highHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'highFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'highTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'highChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'highOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Medium',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'mediumHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'mediumFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'mediumTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'mediumChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'mediumOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Low',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'HCM',
                                  y: {
                                    '#': {
                                      '@': 'lowHcm',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'FIN',
                                  y: {
                                    '#': {
                                      '@': 'lowFin',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'lowTechnical',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'lowChangeManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Other',
                                  y: {
                                    '#': {
                                      '@': 'lowOther',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Team',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    highHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowHcm: {
      filter: {
        and: [
          {
            in: [
              'HCM',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowFin: {
      filter: {
        and: [
          {
            in: [
              'FIN',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowTechnical: {
      filter: {
        and: [
          {
            in: [
              'Technical',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowChangeManagement: {
      filter: {
        and: [
          {
            in: [
              'Change Management',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowOther: {
      filter: {
        and: [
          {
            in: [
              'Other',
              {
                '??': [
                  {
                    '@.': '!team',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
